import React from "react"
import "./LoaderBar.css"
const LoaderBar = () => {
  return <div className="loader"></div>
}
export default LoaderBar
